import React, { useEffect } from 'react';
import './GoogleAd.css';

function GoogleAd({ slot, format = 'horizontal' }) {
  useEffect(() => {
    try {
      // Cargar Google AdSense si no está cargado
      if (window.adsbygoogle && process.env.NODE_ENV === 'production') {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('Error cargando Google Ads:', err);
    }
  }, []);

  // En desarrollo, mostrar un placeholder
  if (process.env.NODE_ENV !== 'production') {
    return (
      <div className={`ad-placeholder ad-${format}`}>
        <div className="ad-placeholder-content">
          <p>· Espacio publicitario ·</p>
          <small>Slot: {slot}</small>
        </div>
      </div>
    );
  }

  return (
    <div className={`google-ad ad-${format}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-4892958163385322"
        data-ad-slot={slot}
        data-ad-format={format === 'horizontal' ? 'horizontal' : 'vertical'}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
}

export default GoogleAd;

